import React from 'react';

class NowCheckbox extends React.Component {
  render() {
    const {
      name, value, onChange, ...rest
    } = this.props;
    return (
      <label className="custom-control custom-checkbox">
        <input
          type="checkbox"
          className="custom-control-input"
          checked={value}
          onChange={onChange}
          {...rest}
        />
        <div className="custom-control-label">
          {name}
        </div>
      </label>
    );
  }
}

export default NowCheckbox;



// WEBPACK FOOTER //
// ./foody/src/components/Common/NowCheckbox.jsx